import { type ComponentPropsWithoutRef, useState } from 'react';
import '../../../../css/create-subtenant.less';
import { TENANT_VIEWS } from '../../constants/tenant';
import { createSubtenant } from '../../sources/tenant';
import translations from '../../translations';
import TenantNameInput from './TenantNameInput';
import { useNotificationDispatch } from '../notifications/NotificationProvider';
import { useTenant } from '../TenantProvider';

interface CreateSubtenantProps {
    navigateTo: (pageId: string) => void;
}

const CreateSubtenant = ({ navigateTo }: CreateSubtenantProps) => {
    const [subtenantName, setSubtenantName] = useState('');
    const [hasSubmitted, setHasSubmitted] = useState(false);
    const [isValid, setIsValid] = useState(false);
    const tenant = useTenant();
    const dispatchNotification = useNotificationDispatch();

    const { developerName: parentTenantName } = tenant;

    const handleInput: ComponentPropsWithoutRef<typeof TenantNameInput>['onChange'] = ({
        value,
        isValid,
    }) => {
        setIsValid(isValid);
        setSubtenantName(value);
    };

    const onCreate = async () => {
        setHasSubmitted(true);

        if (!isValid) {
            dispatchNotification({
                type: 'notifyError',
                payload: { error: translations.TENANT_create_subtenant_invalid_name_error_message },
            });
            return;
        }

        try {
            await createSubtenant(subtenantName);

            navigateTo(TENANT_VIEWS.tenant);
        } catch (error) {
            dispatchNotification({
                type: 'notifyError',
                payload: { error },
            });
        }
    };

    return (
        <>
            <div className="admin-page">
                <div className="create-subtenant-name-input">
                    <TenantNameInput
                        label={translations.TENANT_create_subtenant_name_input_label}
                        value={subtenantName}
                        onChange={handleInput}
                        parentTenantName={parentTenantName}
                        showValidation={hasSubmitted}
                    />
                </div>
            </div>
            <div className="admin-footer">
                <button
                    type="button"
                    className="outcome btn btn-default create-subtenant-cancel"
                    onClick={() => navigateTo(TENANT_VIEWS.tenant)}
                >
                    {translations.TENANT_create_subtenant_cancel_button_label}
                </button>
                <button
                    type="button"
                    className="btn btn-primary outcome create-subtenant"
                    onClick={onCreate}
                >
                    {translations.TENANT_create_subtenant_create_button_label}
                </button>
            </div>
        </>
    );
};

export default CreateSubtenant;
